import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Heart, Calendar, ArrowRight } from 'lucide-react';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 5 && !hasShown) {
        setIsVisible(true);
        setHasShown(true);
      }
    };
    const timeout = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave);
    }, 5000);
    return () => {
      clearTimeout(timeout);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasShown]);
  return <AnimatePresence data-id="element-133">
      {isVisible && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 bg-charcoal/60 backdrop-blur-sm z-[100]" onClick={() => setIsVisible(false)} data-id="element-134" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9
      }} transition={{
        duration: 0.35,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="fixed inset-0 z-[101] flex items-center justify-center p-4" data-id="element-135">
            <div className="bg-white rounded-2xl shadow-2xl overflow-hidden w-full max-w-md" data-id="element-136">
              <div className="bg-olive py-6 px-6 text-center relative" data-id="element-137">
                <button onClick={() => setIsVisible(false)} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors" aria-label="Close popup" data-id="element-138">
                  <X size={16} data-id="element-139" />
                </button>
                <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-3" data-id="element-140">
                  <Calendar size={24} className="text-white" data-id="element-141" />
                </div>
                <h3 className="font-heading text-xl font-bold text-white" data-id="element-142">
                  Before You Go...
                </h3>
              </div>

              <div className="p-6 text-center" data-id="element-143">
                <p className="text-charcoal/80 text-base mb-2 font-medium leading-relaxed" data-id="element-144">
                  Taking the first step is the hardest part.
                </p>
                <p className="text-charcoal/80 text-base mb-6 font-medium leading-relaxed" data-id="element-145">
                  Book a{' '}
                  <strong className="text-charcoal" data-id="element-146">
                    free 15-minute consultation
                  </strong>{' '}
                  to see how therapy can help you — no commitment, no pressure.
                </p>

                <a href="https://esthermensah.janeapp.com/" target="_blank" rel="noopener noreferrer" className="w-full bg-olive hover:bg-olive/90 text-white py-3.5 rounded-lg font-bold text-base transition-all shadow-soft uppercase tracking-wide flex items-center justify-center gap-2 mb-4" data-id="element-147">
                  <Calendar size={18} data-id="element-148" />
                  Book Free Consultation
                </a>

                <a href="tel:5489000692" className="w-full bg-charcoal/5 hover:bg-charcoal/10 text-charcoal py-3 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-2" data-id="element-149">
                  Or Call: 548-900-0692
                </a>

                <p className="text-xs text-charcoal/50 text-center mt-4 font-medium" data-id="element-150">
                  No referral needed. Virtual & in-person available.
                </p>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}